import React, { forwardRef } from 'react';
import { BaseButton } from '../BaseButton';
import { ButtonProps } from './Button.types';
import { BUTTON_SIZES } from './Button.constants';

export const Button = forwardRef<HTMLButtonElement | HTMLAnchorElement, ButtonProps>(
    ({ children, size = 'md', fullWidth, ...rest }, ref) => (
        <BaseButton ref={ref} paddingY="0" width={fullWidth ? '100%' : 'initial'} {...BUTTON_SIZES[size]} {...rest}>
            {children}
        </BaseButton>
    )
);

Button.displayName = 'Button';
